import { createFileRoute, notFound } from '@tanstack/react-router'
import { ssrPublicWork, ssrPublicWorkDetail } from '@/server/ssr-work'
import { workHead } from '@/lib/work-head'
import { PublicWorkPage } from '@/components/ledger/PublicWorkPage'

export const Route = createFileRoute('/{-$locale}/community_/work/$workId')({
  loader: async ({ params }) => {
    const work = await ssrPublicWork(params.workId)
    if (!work) throw notFound()
    const collaboration = await ssrPublicWorkDetail(params.workId)
    if (!collaboration) throw notFound()
    return { ...work, collaboration }
  },
  head: ({ loaderData, params }) =>
    workHead(loaderData, params.workId, params.locale ?? 'en-US'),
  component: () => (
    <PublicWorkPage
      work={Route.useLoaderData()}
      locale={Route.useParams().locale ?? 'en-US'}
      initialDetail={Route.useLoaderData().collaboration}
    />
  ),
})
